var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card', ..._vm.variantClassList]},[_c(!_vm.parentTag ? 'div' : _vm.parentTag,{tag:"component",class:[
			'card__main',
			_vm.parentTag === 'a' && 'card__main--clickable'
		],attrs:{"href":_vm.href}},[(_vm.$slots['card-header'] != undefined)?_c('div',{staticClass:"card__header"},[_vm._t("card-header")],2):_vm._e(),(_vm.$slots['card-body'] != undefined)?_c('div',{staticClass:"card__body"},[_vm._t("card-body")],2):_vm._e()]),(_vm.$slots['card-additional'] != undefined)?_c('div',{class:'card__additional'},[_vm._t("card-additional")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }